package org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.devices.create_new_shop


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CreateShop(
    @SerialName("id")
    val id: String?,
    @SerialName("mod_ver")
    val modVer: Int?,
    @SerialName("name")
    val name: String?,
    @SerialName("regionId")
    val regionId: String?,
    @SerialName("__typename")
    val typename: String?
)